/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetCarouselItems200ResponseAllOfData } from './GetCarouselItems200ResponseAllOfData';
import {
    GetCarouselItems200ResponseAllOfDataFromJSON,
    GetCarouselItems200ResponseAllOfDataFromJSONTyped,
    GetCarouselItems200ResponseAllOfDataToJSON,
} from './GetCarouselItems200ResponseAllOfData';

/**
 * 
 * @export
 * @interface GetCarouselItems200Response
 */
export interface GetCarouselItems200Response {
    /**
     * 
     * @type {GetCarouselItems200ResponseAllOfData}
     * @memberof GetCarouselItems200Response
     */
    data: GetCarouselItems200ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof GetCarouselItems200Response
     */
    meta: object;
}

/**
 * Check if a given object implements the GetCarouselItems200Response interface.
 */
export function instanceOfGetCarouselItems200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetCarouselItems200ResponseFromJSON(json: any): GetCarouselItems200Response {
    return GetCarouselItems200ResponseFromJSONTyped(json, false);
}

export function GetCarouselItems200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCarouselItems200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetCarouselItems200ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function GetCarouselItems200ResponseToJSON(value?: GetCarouselItems200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetCarouselItems200ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

